// import { SwissMap } from '@ta-interaktiv/react-swissmap'
import { ColorLegend } from 'components/color-legend'
import { RankingTable } from 'components/ranking-table'
import { SwissMap } from 'components/SwissMap'
import { colorPalette } from 'Constants/ColorPalette'
import {
  availableIncomeDE,
  availableIncomeFR,
  taxSubjectsDE,
  taxSubjectsFR,
} from 'Constants/TaxSubjects'
import { thousandsSeparators } from 'Constants/ThousandsSeperators'
import * as d3 from 'd3'
import { FC, ReactElement, useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import { Municipality } from 'Types/Municipality'
import { ToolTipProps } from 'Types/toolTipProps'
import { WarningIcon } from 'Assets/WarningIcon'
const FloatingDiv = styled.div`
  margin: 0 auto;
  padding: 1rem;
  background-color: var(--tooltip-background-color);
  border-radius: 3px;
  font-size: 14px;
  font-family: var(--font-plex);
  min-width: 190px;
  /* max-width: 400px; */
  box-shadow: 0 30px 60px rgb(0 0 0 / 8%);
  transition: box-shadow 0.3s ease-in-out;
  margin-bottom: 2em;
  h4 {
    margin: 0;
    display: flex;
    justify-content: space-between;
    font-size: 1.25em;
    margin-bottom: 0;
    font-weight: 700;
    text-align: left;
  }
  table {
    /* th{
    border-bottom: 1px solid rgba(128, 128, 128, 0.1);
    } */
    width: 100%;
    tbody {
      tr {
        line-height: 1.5em;
        .bold {
          font-weight: bold;
        }
        .price {
          font-weight: bold;
          white-space: nowrap;
          text-align: right;
          line-height: 0em;
          padding: 0;
          max-height: 0.5em;
          transition: color 0.3s ease-in-out;
        }
        .green {
          color: var(--green-main);
        }
        .red {
          color: var(--red-main);
        }
      }
      .last-row {
        td {
          padding-bottom: 0.5em;
        }
      }
      .rank {
        td {
          margin-top: 3em;
          padding-top: 0.6em;

          border-top: 2px solid #dedede;
          color: currentColor;
          text-align: center;
          font-size: 0.85em;
          font-weight: 600;
          text-transform: uppercase;
        }
      }
    }
  }
`
const MapSection: FC<{ bfsIdParamName: string; locale: 'de' | 'fr' }> = ({
  bfsIdParamName,
  locale,
}): ReactElement => {
  const [activeMunicipality, setActiveMunicipality] = useState<Municipality>()
  const [activeMunicipalityId, setActiveMunicipalityId] = useState<number>()
  const [taxMinValue, setTaxMinValue] = useState<number>(0)
  const [taxMaxValue, setTaxMaxValue] = useState<number>(1)
  const [colorFunction, setColorFunction] = useState<any>()
  const [lastRank, setLastRank] = useState<number>(2206) // todo get correct last rank
  const [municipalityData, setMunicipalityData] = useState<any>([])
  const [selectedTaxSubject, setSelectedTaxSubject] = useState<number>(15)
  const [selectedIncome, setSelectedIncome] = useState<number>(150000)
  const [preselectedMunicipality, setPreselectedMunicipality] = useState<any>()
  const searchParams = new URL(String(window.location)).searchParams
  const muniParam = searchParams.get(bfsIdParamName)
  const bfsIdFromUrl = muniParam && parseInt(muniParam)
// // switch selectedIncome every second
//   setTimeout(() => {
//     const oldIndex = availableIncomeDE.map((i) => i.value).indexOf(selectedIncome)
//     setSelectedIncome(availableIncomeDE.map((i) => i.value)?.[Math.max((oldIndex + 4 )% availableIncomeDE.length, 15) ])
//   }, 1500)


  const ToolTip: React.FC<ToolTipProps> = ({
    activeData = {
      GDENAME_de: 'Keine Daten',
    },
  }): ReactElement => {
    return (
      <FloatingDiv>
        {activeData && (
          <>
            <table>
              {
                <thead>
                  <tr>
                    <th colSpan={2}>
                      {' '}
                      <h4>
                        {activeData?.['name_' + locale]
                          ? activeData?.['name_' + locale] +
                            ' (' +
                            activeData?.canton +
                            ')'
                          : locale === 'fr'
                          ? 'pas de données'
                          : 'keine Daten'}
                      </h4>
                    </th>
                  </tr>
                </thead>
              }
              {activeData.taxloadrelative !== undefined && (
                <tbody>
                  <tr>
                    <td>{locale === 'fr' ? 'Charge:' : 'Belastung:'}</td>
                    <td className='bold price'>
                      {activeData.taxloadrelative.toFixed(2).replace(".",",")}%
                    </td>
                  </tr>
                  <tr>
                    <td>{locale === 'fr' ? 'Impôt dû:' : 'Fällige Steuer:'}</td>
                    <td className='bold price'>
                      {thousandsSeparators(
                        +(
                          (+activeData.taxloadrelative / 100) *
                          selectedIncome
                        ).toFixed(2)
                      ) + ' CHF'}
                    </td>
                  </tr>
                  {activeData.taxloadrelativediff !== null &&
                    activeData.taxloadrelativediff !== undefined && (
                      <tr className='last-row'>
                        <td>
                          {locale === 'fr'
                            ? 'Variation:'
                            : 'Gegenüber dem Vorjahr:'}
                        </td>
                        <td
                          className={
                            (activeData.taxloadrelativediff < 0
                              ? 'green '
                              : activeData.taxloadrelativediff > 0
                              ? 'red '
                              : '') + 'bold price'
                          }
                        >
                          {activeData.taxloadrelativediff > 0 ? '+' : ''}
                          {thousandsSeparators(
                            +(
                              (+activeData.taxloadrelativediff / 100) *
                              selectedIncome
                            ).toFixed(2)
                          ) + ' CHF'}
                        </td>
                      </tr>
                    )}
                  <tr className='rank'>
                    <td colSpan={2}>
                      Rang <span>{thousandsSeparators(activeData.rank)}</span>/
                      {lastRank}
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          </>
        )}
      </FloatingDiv>
    )
  }
  const fetchData = (prevActiveBfsId?: number) => {
    import(
      '../../Assets/json/2022_' +
        selectedTaxSubject +
        '_' +
        selectedIncome +
        '.json'
    ).then((formattedData) => {
      setMunicipalityData(formattedData.municipalities)
      setTaxMinValue(formattedData.extent[0])
      setTaxMaxValue(formattedData.extent[1])
      // console.log('setting new max value', formattedData.extent[1])
      // console.log(formattedData.municipalities.filter((muni:any)=>muni.taxloadrelativediff === null));
      
      setLastRank(
        Math.max(...formattedData.municipalities.map((muni: any) => muni.rank))
      )
      setColorFunction(
        d3
          .scaleLinear()
          .domain([
            formattedData.extent[0],
            (formattedData.extent[0] + formattedData.extent[1]) / 2,
            formattedData.extent[1],
          ])
          .range(colorPalette as any)
      )

      if (prevActiveBfsId) {
        setActiveMunicipality(
          formattedData.municipalities.find(
            (muni: any) => muni.bfsId === prevActiveBfsId
          )
        )
      }
      if (prevActiveBfsId === undefined && bfsIdFromUrl !== undefined) {
        setActiveMunicipality(
          formattedData.municipalities.find(
            (muni: any) => muni.bfsId === bfsIdFromUrl
          )
        )
      }
    })
  }
  useEffect(() => {
    fetchData(activeMunicipality?.bfsId)
  }, [selectedTaxSubject, selectedIncome])
  useEffect(() => {
    setActiveMunicipality(
      municipalityData.find((muni: any) => muni.bfsId === activeMunicipalityId)
    )
  }, [activeMunicipalityId])
  useEffect(() => {
    const handleEvent = (event: CustomEvent) => {
      setActiveMunicipalityId(event.detail)
    }
    window.addEventListener('changeGDE' as keyof WindowEventMap, handleEvent as any)
    return () => {
      window.removeEventListener('changeGDE' as keyof WindowEventMap, handleEvent as any)
    }
  }, [])
  return (
    <Wrapper>
      <h2>
        {locale === 'fr'
          ? 'Où se trouve votre paradis fiscal?'
          : 'Wo liegt Ihr Steuerparadies?'}
      </h2>
      {/* <Hint>
        <WarningIcon />
        {locale === 'fr'
          ? ''
          : 'Es handelt sich um Gemeinde-, Kantons- und Bundessteuern (ohne Kirchen- und Vermögenssteuern).'}
      </Hint> */}
      <DropdownWrapper>
        <div>
          <label htmlFor='taxSubject'>
            {locale === 'fr'
              ? 'Choisissez le modèle de calcul'
              : 'Wählen Sie das Berechnungsmodell'}
          </label>
          <Dropdown
            name='taxSubject'
            id='taxSubject'
            value={selectedTaxSubject}
            onChange={(event) => {
              setSelectedTaxSubject(+event.target.value)
            }}
          >
            {(locale === 'fr' ? taxSubjectsFR : taxSubjectsDE).map(
              (taxSubject, index) => (
                <option key={taxSubject} value={index + 1}>
                  {taxSubject}
                </option>
              )
            )}
          </Dropdown>
        </div>
        <div>
          <label htmlFor='income'>
            {locale === 'fr'
              ? 'et le revenu annuel brut en CHF'
              : 'und das jährliche Bruttoeinkommen in Franken'}
          </label>
          <Dropdown
            name='income'
            id='income'
            value={selectedIncome}
            onChange={(event) => {
              setSelectedIncome(+event.target.value)
            }}
          >
            {(locale === 'fr' ? availableIncomeFR : availableIncomeDE).map(
              (income, index) => (
                <option key={income.text} value={income.value}>
                  {income.text + ' CHF'}
                </option>
              )
            )}
          </Dropdown>
        </div>
      </DropdownWrapper>
      <MapWrapper>
        <SwissMap
          activeMunicipalityId={activeMunicipality?.bfsId}
          colorPalette={colorPalette as any}
          propertyNameToCompare={'taxloadrelative'}
          municipalityData={municipalityData}
          minValue={taxMinValue}
          maxValue={taxMaxValue ?? 1}
          topoJsonYear={2022}
          ToolTip={ToolTip}
          hideMunicipalitySearch={false}
          municipalitySearchYear={'20220101'}
          locale={locale}
          // zoomIntoActiveMunicipality
          newActiveMunicipalityIdHandler={setActiveMunicipalityId}
        />
        {taxMaxValue && (
          <ColorLegend
            colorPalette={colorPalette}
            minVal={taxMinValue}
            maxVal={taxMaxValue}
            currentValue={activeMunicipality?.taxloadrelative}
          />
        )}
        {activeMunicipality && (
          <StaticToolTipWrapper>
            <ToolTip activeData={activeMunicipality} />
          </StaticToolTipWrapper>
        )}
      </MapWrapper>
      <RankingTable
        municipalityData={municipalityData}
        colorPalette={colorPalette}
        minValue={taxMinValue}
        maxValue={taxMaxValue}
        activeMunicipalityId={activeMunicipalityId}
        onSelectionHandler={setActiveMunicipalityId}
        locale={locale}
      />
    </Wrapper>
  )
}
const Wrapper = styled.div`
  font-family: var(--font-plex);
  font-size: 1.8rem;
  line-height: 3rem;
  max-width: 1200px;
  margin: 0 auto;
  h2 {
    margin-top: 0;
    margin-bottom: 2rem;
  }
  #tooltip {
    transition: opacity 0.2s ease-in-out;
    opacity: 0;
  }
  #tooltip.active {
    div {
      box-shadow: 0 30px 60px rgb(0 0 0 / 8%);
    }
    opacity: 1;
  }
  #tooltip.disabled {
    div {
      box-shadow: 0 0px 0px rgb(0 0 0 / 8%);
    }
    opacity: 0;
  }

  #swiss-choropleth-map {
    path {
      transition: fill 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
    // min height on mobile
    /* @media (max-width: 768px) {
      min-height: 284px;
    } */
    // min height on desktop
    @media (min-width: 768px) {
      min-height: 523px;
    }
    svg {
      /* max-height: 850px;
      @media (max-width: 768px) {
      max-height: 500px;
    }
    min-width: 100%; */
      aspect-ratio: 1.5 / 1;
    }
  }
  .municipality-search {
    margin-bottom: 2em;
    svg {
      stroke: var(--text-color) !important;
    }
    #search {
      font-size: 18px;
      background-color: var(--selection-background);
      color: var(--text-color);
    }
    .results {
      overflow: hidden;
      @media (min-width: 768px) {
        position: absolute;
      }
      display: flex;
      .result {
        max-width: 100%;
        background-color: var(--selection-background);
        color: currentColor;
      }
      flex-direction: column;
      pointer-events: auto;
      background-color:none;

    }
  }
`
const Hint = styled.div`
  font-size: 0.85em;
  line-height: 1.3em;
  margin-bottom: 1em;
  display: flex;
  align-items: center;
  background-color: var(--hint-background);

  padding: 1em;
  border-radius: 5px;
  svg {
    max-height: 1.5em;
    margin-right: 0.5em;
    min-width: 1em;
    /* transform: translateY(.1em); */
  }
`
const Dropdown = styled.select`
  margin-top: 0.5em;
  color: currentColor;
  width: 100%;
  height: 3.5rem;
  border: 1px solid #cccccc74;
  border-radius: 0.3rem;
  padding: 0.5rem;
  font-size: 1.8rem;
  line-height: 3rem;
  font-family: var(--font-plex);
  background-color: var(--selection-background);
  background-image: none;
`
const DropdownWrapper = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 1rem;
  gap: 1em;
  label {
    margin-bottom: 0.5rem;
    font-size: 0.85em;
  }
  line-height: 1em;
`
const MapWrapper = styled.div`
  position: relative;
`
const StaticToolTipWrapper = styled.div`
  @media (min-width: 768px) {
    position: absolute;
    top: 0;
    right: 0;
  }
  div {
    width: 100%;
  }
  z-index: 100;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
`

export default MapSection
